module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_323713546_L-small-7762e8fbd55972853551c89cfcd23a17.jpg";